import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { ArrowRightIcon, Eyebrow, Swoosh } from "../../../components/design";

type HeroProps = {
  eyebrow: string;
  // The full H1 with one accent word wrapped in <Swoosh>. Pass JSX directly.
  h1: ReactNode;
  lead: ReactNode;
};

// Editorial hero used across all 8 marketing landing pages. Mobile-first,
// centred on desktop.
export default function Hero({ eyebrow, h1, lead }: HeroProps) {
  return (
    <section style={{ padding: "32px 0 12px" }}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1
        style={{
          fontFamily: "var(--f-display)",
          fontWeight: 400,
          fontSize: 38,
          lineHeight: 1.04,
          letterSpacing: "-0.018em",
          margin: "0 0 18px",
          color: "var(--ink)",
        }}
      >
        {h1}
      </h1>
      <p
        style={{
          fontFamily: "var(--f-display)",
          fontSize: 18,
          lineHeight: 1.55,
          color: "var(--ink)",
          margin: "0 0 22px",
        }}
      >
        {lead}
      </p>

      <Link
        to="/onboarding"
        className="btn-primary"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "14px 22px",
          fontSize: 15,
          minHeight: 0,
        }}
      >
        Jetzt verschenken
        <ArrowRightIcon />
      </Link>

      <p
        style={{
          marginTop: 12,
          fontFamily: "var(--f-body)",
          fontStyle: "italic",
          fontSize: 13,
          lineHeight: 1.5,
          color: "var(--ink-faint)",
        }}
      >
        Aufnahmen, Texte, Rechte bleiben bei der erzählenden Person.
      </p>
    </section>
  );
}

// Re-export Swoosh for convenience in page files.
export { Swoosh };
